import App from './App.svelte';
// import "tailwindcss/tailwind.css";

// Handle GitHub Pages SPA routing
let url = '';

// Check if we have a path redirect from GitHub Pages
// The '?p=/page' format comes from our 404.html redirect
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const path = params.get('p');
  
  if (path) {
    // Remove the query parameter from the URL without reloading the page
    const newUrl = window.location.pathname + 
      window.location.search.replace(/(\?|&)p=[^&]*(&|$)/, '$1').replace(/\?$/, '') + 
      window.location.hash;
    
    window.history.replaceState(null, '', path);
    url = path;
  } else {
    // If no redirect is present, use the current pathname
    url = window.location.pathname || '';
  }
}

// Log the current path for debugging
if (typeof window !== 'undefined') {
  console.log('Initial path:', window.location.pathname);
  console.log('Initial URL:', url);
  
  // Add popstate listener for debugging
  window.addEventListener('popstate', () => {
    console.log('Navigation occurred:', window.location.pathname);
  });
}

const app = new App({
	target: document.body,
	props: {
    url: url,  // Pass the corrected URL to our app
  },
});

export default app;